import React from 'react';
import { Link } from 'react-router-dom';
import './brand.css';

/**
 * Canonical ByOnco wordmark, lowercase "byonco" everywhere.
 * Use `mark` for the gradient PNG (hero / dark surfaces).
 * Use tone="inverse" on dark backgrounds.
 */
export default function BrandLogo({
  to = '/',
  className = '',
  variant = 'wordmark',
  size = 'md',
  tone = 'default',
  onClick,
  testId,
  as = 'link',
  style,
}) {
  const classes = [
    'byo-brand',
    `byo-brand--${variant}`,
    `byo-brand--${size}`,
    tone === 'inverse' ? 'byo-brand--inverse' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const inner =
    variant === 'text' ? (
      <span className="byo-brand-label vani-brand-label">byonco</span>
    ) : (
      <>
        <img
          src="/assets/byonco-logo-transparent.png"
          alt="ByOnco Logo"
          className="byo-brand-img"
          style={style}
          decoding="async"
        />
        <span className="sr-only vani-brand-label">byonco</span>
      </>
    );

  if (as === 'span') {
    return (
      <span className={classes} data-testid={testId} aria-label="ByOnco">
        {inner}
      </span>
    );
  }

  const external = typeof to === 'string' && /^https?:\/\//i.test(to);
  if (external) {
    return (
      <a
        href={to}
        className={classes}
        aria-label="ByOnco"
        onClick={onClick}
        data-testid={testId}
      >
        {inner}
      </a>
    );
  }

  return (
    <Link
      to={to}
      className={classes}
      aria-label="ByOnco"
      onClick={onClick}
      data-testid={testId}
    >
      {inner}
    </Link>
  );
}
